// RC49-GOV-001…006 — canonical product naming shared by every dealer/admin surface.
export const FAMILY_BY_FORMAT = {
  "4x4": { family: "Zellige Mzedej", mounting: "Loose", unit: "box" },
  "2x6": { family: "Bejmat", mounting: "Loose", unit: "box" },
  "2x2": { family: "Mdebdeb", mounting: "Mesh-mounted", unit: "sheet" },
};
export const FORMAT_OPTIONS = [
  { value: "all", label: "All formats" },
  { value: "4x4", label: "4×4 Zellige Mzedej" },
  { value: "2x6", label: "2×6 Bejmat" },
  { value: "2x2", label: "2×2 Mdebdeb" },
];

export const normalizeFormat = (v) => String(v || "").toLowerCase().replace(/×/g, "x").replace(/\s+/g, "");

export function canonical(v) {
  const fmt = normalizeFormat(v?.format_in || v?.format);
  const meta = FAMILY_BY_FORMAT[fmt];
  if (!meta) return { format: v?.tile_size_in || v?.format_in || "", family: v?.product_name || "Zellige", mounting: v?.presentation || "Loose", unit: "box" };
  return { format: v?.tile_size_in || fmt.replace("x", "×"), ...meta };
}

// RC49-NC-001 global canonical title: "[Family] / [Moroccan] / [U.S.] · [Format] [Glaze] · [Presentation]"
const GLAZE_STATES = new Set(["UNGLAZED", "GLAZED", "MATTE", "SEMI-GLOSS", "SEMI GLOSS", "GLOSS"]);
export function productTitle(v) {
  const c = canonical(v);
  const fam = c.family.replace("Zellige ", "");
  const moroccan = (v?.color_name || "").trim();
  let us = (v?.us_color_name || "").trim();
  let glaze = (v?.glaze || "").trim();
  if (!glaze && GLAZE_STATES.has(us.toUpperCase())) { glaze = us; us = ""; }
  const names = [fam, moroccan, us && us.toUpperCase() !== moroccan.toUpperCase() ? us : ""].filter(Boolean).join(" / ");
  const g = glaze ? ` ${glaze.charAt(0).toUpperCase()}${glaze.slice(1).toLowerCase()}` : "";
  return `${names} · ${c.format}${g} · ${c.mounting}`;
}

export function fold(s) {
  return String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
    .replace(/×/g, "x").replace(/(\d)\s*x\s*(\d)/g, "$1x$2").replace(/mz[\s-]?(\d+)/g, "mz$1").replace(/\s+/g, " ").trim();
}

// GOV-004 / INV-005/006 / PRC-013: alias-aware matcher.
export function matchesProduct(query, v) {
  const q = fold(query);
  if (!q) return true;
  const c = canonical(v);
  const fmt = normalizeFormat(v?.format_in);
  const hay = [v?.sku, v?.color_code, v?.color_name, v?.us_color_name, v?.moroccan_color_name, c.family, c.mounting, fmt, v?.format_in]
    .filter(Boolean).map(fold).join(" ");
  return q.split(" ").every((t) => hay.includes(t));
}

// GOV-006: value + unit stay one semantic group.
export const vu = (value, unit) => `${value}\u00a0${unit}`;
